const textFields = ['simple-text', 'url', 'phone', 'email', 'abn', 'state', 'postcode', 'number', 'money', 'password']

export const testTextField = fieldType => textFields.indexOf(fieldType) !== -1
